import { Injectable } from '@angular/core';
import { HttpClient, HttpClientJsonpModule } from '@angular/common/http';
import 'rxjs/Rx';

@Injectable({
	providedIn: 'root',
})
export class DataService {
	public value = 'Probando';
	constructor(private http: HttpClient) {}

	get(url: string): Promise<any> {
		return new Promise((resolve) => {
			return this.http.get(url).subscribe((data) => {
				resolve(data);
			});
		});
	}

	post(url: string, values): Promise<any> {
		return new Promise((resolve) => {
			return this.http
				.post<any>(url, values, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					},
				})
				.subscribe(
					(data) => {
						resolve(data);
					},
					(error) => {}
				);
		});
	}

	postNewCampaign(url: string, values: { campaign: any; criterias: any; campaign_info: any }): Promise<any> {
		return new Promise((resolve) => {
			return this.http
				.post<any>(url, values, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					},
				})
				.subscribe(
					(data) => {
						resolve(data);
					},
					(error) => {}
				);
		});
	}

	postObservable(url: string, values: any) {
		return this.http.post<any>(url, values, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			},
		});
	}

	getObservable(url: string) {
		return this.http.get(url);
	}

	postObservableSimple(url: string, data: any) {
		return this.http.post(url, data);
	}
}
